/* @flow */
// typecheck: ignore file
import React from 'react';
import ReactJoyride from 'react-joyride';
import AdminSignupJoyrideModal from 'app/components/AdminSignupJoyrideModal.jsx';
import { mountModal } from 'lib/modal';

type Props = {
  run: boolean,
  steps: Object[],
  callback: Function,
};

type State = {
  closedModal: boolean,
}

class AdminSignupJoyride extends React.Component {
  props: Props;
  state: State = {
    closedModal: false,
  };

  componentDidMount() {
    if (this.props.run) {
      this.startRide();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.run && this.props.run) {
      this.startRide();
    }
  }

  onModalClose = () => {
    this.setState({ closedModal: true });
  }

  startRide() {
    mountModal(<AdminSignupJoyrideModal onClose={this.onModalClose} />, this);
  }

  render() {
    if (!this.state.closedModal) {
      return null;
    }

    return (
      <ReactJoyride
        autoStart
        showStepsProgress
        type="continuous"
        scrollToSteps={false}
        showBackButton={false}
        locale={{ back: 'Back', close: 'Close', last: 'Close', next: 'Next', skip: 'Skip' }}
        {...this.props}
      />
    );
  }
}

export default AdminSignupJoyride;



// WEBPACK FOOTER //
// ./src/app/components/AdminSignupJoyride.jsx